<app-table
    [translatePrefix]="prefix"
    [columns]="columns()"
    [gridData]="store.data.getServiceTypes()"
    (detailCallback)="detailCallback($event)"
    [refreshCallback]="store.api.getServiceTypes"
    [refreshCallbackFragment]="getServiceTypesFrag"
>
    <ng-template pTemplate="expertise" let-data="data">
        <div class="flex flex-column gap-x-small">
            <div>{{ data.code }}</div>
            <div class="font-size-small">{{ data.name }}</div>
        </div>
    </ng-template>
</app-table>
